// ID Card Types for ID Card Details Module
export const idCardTypes = [
  "Passport",
  "Driving License",
  "Aadhaar Card",
  "APAAR ID",
  "PAN Card",
  "Voter ID Card",
  "National ID Card",
  "Social Security Card",
  "Health Insurance Card",
  "Employee ID Card",
  "Student ID Card",
  "Ration Card",
  "Birth Certificate",
  "Marriage Certificate",
  "Other",
];

export default idCardTypes;
